export default {
  __contact_specialist: "Contact Specialist",
  __last_update: "Last Update",
  __last_updated: "Last Updated: ",
  __menu_header: "MENU",
  __updated: "Updated",
  __request: "Request",
  __daily: "Daily",
  __weekly: "Weekly",
  __monthly: "Monthly",
  __date: "Date",
  __month: "Month",
  __today: "Today",
  __yesterday: "Yesterday",
  __last_7_days: "Last 7 days",
  __last_week: "Last week",
  __last_30_days: "Last 30 days",
  __last_month: "Last Month",
  __no_data: "Have no data",
  __loading: "Loading...",
  __example: "Example",
  __clicks: "Clicks",
  __cost: "Cost",
  __impressions: "Impressions",
  __ctr: "CTR",
  __cpc: "CPC",
  __avg_cpc: "Avg. CPC",
  __conversion: "Conversion",
  __campaigns: "Campaigns",
  __keywords: "Keywords",
  __audiences: "Audiences",
  __days: "Days",
  __metrics: "Metrics",
  __amount: "Amount",
  __display: "Display: ",
  __apply: "Apply",
  __cancel: "Cancel",
  __save: "Save",
  __confirm: "Confirm",
  __date_on: "Date on",
  __total_column: "<0>Total</0> <1>{{count}}</1>",
  __toast_warning_limit_alternate_column:
    "Can only choose {{count}} matrice(s), please remove before adding a new one.",
  __selected_metrics: "Selected Metrics",
  __available_metrics: "Available Metrics",
  __open_contact: "Call us at 02-016-6789",
  __settings_menu: "Settings",
  __my_drive: "My Drive",
  __shared_drive: "Shared drives",
  __shared_with_me: "Shared with me",
  __disconnected: "Disconnected",
  __gate_label: "Choose Gate",
  __add_connection: "Add Connection",
  __delete: "Delete",
  __edit: "edit",
  __connection_problem: "Something is wrong with the connection.",
  __edit_time: "Updated on",
  __by: "by",
  __all: "All",
  __custom: "Custom",
  __deleted: "deleted",
  __file_name: "File Name",
  __file_position: "Position",
  __file_updated_date: "Updated On",
  __file_updated_by: "Updated By",
  __save_success: "Save successful.",
  __save_failed: "Save failed.",
  __confirm_delete: "Do you confirm to delete this connection?",
  __delete_success: "The connection has been deleted successfully.",
  __delete_failed: "Failed to delete the connection.",
  __show_more: "Show more",
  __used: "Used for other connections",
  __select_form_warning: "Please select at least one form.",
  __sheets_input_warning: "Please specify a valid URL.",
  __browse: "Browse",
  __selected_form_warning: "The form you selected has been used for other connections.",
  __fb_error_permission_denied: "You don't have permission to access this Facebook Page.",
  __fb_error_token_expire: "Your session has expired.",
  __google_error_file_permission_denied: "You don't have permission to access this file.",
  __google_error_token_expire: "Your session has expired.",
  __google_error_gsheet_not_found: "Google Sheets not found.",
  __google_error_403_insert_fail: "You don't have permission to edit this file.",
  __rcrm_error_gate_lost: "Gate not found in R-CRM.",
  __lead_step: "Lead Step",
  __form_id: "Form ID",
  __file_info_error: "Google Sheets not found or something is wrong with the connection. Please edit connection.",
  __connection_try_again: "Please sign in again.",

  //Dashboard
  __dashboard: "Dashboard",
  __dashboard_spending: "Spending",
  __dashboard_conversion: "Conversions",
  __dashboard_top_keyword: "Keyword:",
  __dashboard_top_campaign: "Campaigns:",
  __dashboard_top_click: "Clicks:",
  __top_5_keywords: "Top 5 Keywords Clicked",
  __see_all_keywords: "See All Keywords",
  __remaining_budget: "Remaining Budget",
  __avg_daily_spend: "Avg. Daily Spend",
  __estimated_exhaust: "Estimated days to exhaust",

  //Contact
  __contact_title: "Contact",
  __contact_tel: "Tel: ",
  __contact_email: "Email: ",
  __contact_click_to_call: "Call",
  __contact_click_email: "Email",

  //Suggestion
  __adpro_suggestion: "R-Ads Suggestions",
  __average_cpa: "Average CPA",
  __suggestion_campaing: "Campaigns:",
  __suggestion_click: "Click",
  __suggestion_conversion: "Conversion",
  __cpa_is_above_avg: "CPA is above average",
  __daily_budget: "Daily Budget:",
  __suggestion_keyword: "Keyword:",
  __low_performance_keyword: "Low Performance Keywords",
  __no_tracking_data: "No Tracking Data",
  __no_tracking_data_desc:
    "Please contact your specialist to connect to R-Widget for collecting the data from your website",
  __opportunity: "Opportunities",
  __raise_daily_budget: "Increase daily budget by",
  __spending: "Spending",
  __suggestion: "Suggestion",

  //payment
  __payment: "Payment",
  __payment_history: "Payment History",
  __recent_items: "Recent items",
  __days_to_exhust: "<0>{{count}} days to exhaust</0>",
  __estimate_on_current_budget: "Estimated on current budget",

  //Account Performance
  __account_performance: "Account Performance",
  __comparison: "Comparison",
  __comparison_period: "Choose the period you would like to see",
  __trending: "Trending",

  // RMP Conversions
  __rmp_conversions: "Offline Conversions",

  //campaigns
  __search_campaign: "Search Campaigns",
  __display_campaign: "Display Campaigns",
  __placements: "Placements",
  __top_20_keywords: "Top 20 Keywords",
  __top_20_audiences: "Top 20 Audiences",
  __top_20_placements: "Top 20 Placements",
  __campaign: "Campaigns",

  //Wizard
  __setup_ads: "Setup Ads Account",
  __google_ads: "Google Ads Account",
  __facebook_ads: "Meta Ads Account",
  __business_name: "Business Name",

  //Settings
  __ads_account: "Ads Account",
  __back_to_dashboard: "Back to Dashboard",
  __change_ads_error: "Change Ads account failed. Please try again later.",

  // Google Ads
  __ads_label_google_ads_account: "Google Ads Account",
  __ads_setup_description:
    "Linking your Google Ads account with Readyplanet (Google Partner) to allow our system to collect statistics from your Google Ads account and generate useful analytics report sending to you. Our system will also create conversions of each Google Ads campaign and keyword then this conversion will enable you to bid by conversion and optimize your advertising budget more effectively.",
  __ads_setup_learn_more: "Learn more about",
  __ads_setup_learn_more_link: "linking accounts to Manager accounts.",
  __ads_setup_manual_link: "Learn more",
  __ads_setup_policy_link: "Terms and Conditions",
  __ads_setup_privacy_link: "Privacy Policy",
  __ads_setup_filter_placeholder: "Search by Google Ads account name or ID",
  __ads_setup_title: "Ads Account",
  __ads_setup_subtitle: "Enter your preferred Google Ads account to connect with Readyplanet (Google Partner).",
  __ads_setup_selection_subtitle:
    "Choose your preferred Google Ads account to connect with Readyplanet (Google Partner).",
  __ads_setup_use_other_account: "use another Google account.",
  __ads_setup_or: "Or",
  __ads_setup_save: "Save",
  __ads_setup_save_success: "Save successful.",
  __ads_setup_save_failed: "Unable to connect to Google Ads account.",
  __ads_setup_validate_params_failed: "Please select or enter your Google Ads account.",
  __ads_setup_no_available_ads: "This account does not have a Google Ads account.",
  __ads_connected_account_name: "Account",
  __ads_connected_account_status: "Status",
  __ads_connected_account_connected: "Connected",
  __ads_connected_account_not_connected: "Connection Problem",
  __ads_connected_account_edit: "Edit",
  __ads_offline_conversion_title: "Offline Conversions",
  __ads_offline_conversion_sync: "Send data from R-Ads to Google.",
  __ads_offline_conversion_active: "Active",
  __ads_offline_conversion_save_success: "Save successful.",
  __ads_offline_conversion_save_failed: "Save failed.",
  __ads_offline_conversion_active_confirm: "Do you confirm to activate Offline Conversions?",
  __ads_offline_conversion_inactive_confirm: "Do you confirm to deactivate Offline Conversions?",
  __ads_offline_conversion_confirm_button: "Confirm",
  __ads_offline_conversion_cancel_button: "Cancel",
  __ads_widget_description:
    "Statistical data and visitor behavior will be sent as Offline Conversions to the Google Ads account. The advertisers can use this data for Smart Bidding.",
  __ads_widget_action: "Action",
  __ads_widget_conversion_name: "Conversion Name",
  __ads_widget_action_form: "Form Actions",
  __ads_widget_action_call: "Call Actions",
  __ads_widget_action_line: "LINE Actions",
  __ads_widget_action_facebook: "Facebook Actions",
  __ads_widget_action_others: "Other Actions",
  __ads_widget_action_behavior: "Visitor Behavior",
  __ads_widget_action_last_update: "Last Updated",
  __ads_widget_action_callback_form: "Callback",
  __ads_widget_action_google_maps: "Maps",
  __ads_widget_action_zalo: "Zalo",
  __ads_widget_action_skype: "Skype",
  __ads_widget_action_whatsapp: "Whatsapp",
  __ads_widget_action_rchat: "R-Chat",
  __ads_widget_action_custom_button: "Custom Button",
  __ads_widget_action_total_action: "Every contact actions",
  __ads_crm_description:
    "Data will be sent to the Google Ads account via your preferred lead pipeline, and you can choose whether or not to send the data.",
  __ads_crm_conversion_active_confirm: "Confirm to send data to Google Ads account",
  __ads_crm_conversion_inactive_confirm: "Confirm to unsend data to Google Ads account",
  __ads_crm_conversion_confirm_button: "Confirm",
  __ads_crm_conversion_cancel_button: "Cancel",
  __ads_crm_conversion_sync: "Send data to Google Ads account.",
  __ads_crm_conversion_send_data: "Send Data",
  __ads_crm_conversion_unsend_data: "Unsend Data",
  __ads_crm_conversion_name: "Conversion Name",
  __ads_crm_conversion_save_success: "Save successful.",
  __ads_crm_conversion_save_failed: "Save failed.",
  __ads_crm_conversion_last_update: "Last Updated",
  __ads_conversion_no_data: "Nothing to display.",
  __ads_crm_lead_pipeline: "Lead Pipeline",
  __ads_crm_lead_step: "Lead Step",
  __ads_crm_following_lead: "Following Lead",
  __ads_crm_unfollowed_lead: "Unfollowed Lead",
  __ads_performance_all_option: "All",
  __ads_crm_lead_conversion_value: "Value",

  __ads_initial_value: "Initial Value",
  __ads_conversion_set_button: "Create Custom Conversion",
  __ads_conversion_set_table_header_set_name: "Name",
  __ads_conversion_set_table_header_lead_source: "Lead Source",
  __ads_modal_conversion_set_title_add: "Create Custom Conversion",
  __ads_modal_conversion_set_title_edit: "Edit Custom Conversion",
  __ads_modal_conversion_set_title_view: "Custom Conversion",
  __ads_modal_delete_conversion_set_message: "Do you want to delete this Conversion Set?",
  __ads_title_standard_conversion: "Conversion by Lead Steps and Status",
  __ads_titlle_conversion_set: "Setting Conversion Set Based on Lead Source",
  __ads_tooltip_conversion_set: "Send conversion data to Google Ads account when lead has specified source",
  __ads_google_sheets_description: "Data will be sent to Google Ads account.",
  __ads_google_sheets_conversion_sync: "Send data to Google Ads account",
  __ads_google_sheets_conversion_send_data: "Send Data",
  __ads_google_sheets_conversion_unsend_data: "Unsend Data",
  __ads_google_sheets_conversion_name: "Conversion Name",

  // Facebook Ads
  __fbads_facebook_setting_edit_on_rdynamic: "You can set up your Facebook account on R-Dynamic. To configure,",
  __fbads_facebook_setting_edit_on_rdynamic_click_here: "click here.",
  __fbads_facebook_setting_error_occurred: "Something went wrong. Please try again later.",
  __fbads_facebook_setting_validate_failed: "Please validate your data.",
  __fbads_conversion_sync: "Send data from R-Ads to Meta.",
  __fbads_widget_description:
    "Statistical data and visitor behavior will be sent as Web Conversions to the Meta Ads account. The advertisers can use this data for Smart Bidding.",
  __fbads_rcrm_conversion_sync: "Send data to Meta Ads account.",
  __fbads_conversion_active_confirm: "Confirm to send data to Meta Ads account",
  __fbads_conversion_inactive_confirm: "Confirm to unsend data to Meta Ads account",
  __fbads_crm_description:
    "Data will be sent to the Meta Ads account via your preferred lead pipeline, and you can choose whether or not to send the data.",
  __fbads_setup_title: "Ads Account",
  __fbads_setup_setting_button: "Settings",
  __fbads_setup_sub_title: "Connect R-Ads with your Facebook account.",
  __fbads_setup_save_success: "Save successful.",
  __fbads_setup_save_failed: "Unable to connect to Facebook account.",
  __fbads_setup_account_business: "Business Account",
  __fbads_setup_account_ads: "Ads Account",
  __fbads_setup_account_pixel: "Pixel ID",
  __fbads_setup_error_no_business: "Please select a Business account.",
  __fbads_setup_error_no_ads_account: "Please select an Ads account.",
  __fbads_setup_error_access_ads_account: "This Facebook user cannot access this Ads account.",
  __fbads_setup_error_no_pixel: "Please insert a Pixel ID.",
  __fbads_setup_error_access_pixel: "Unable to access this Pixel ID.",
  __fbads_setup_error_connected_pixel_ads: "Pixel ID is not linked to the Ads account.",
  __fbads_setup_change_account_button: "Change Facebook account",
  __fbads_setup_save_button: "Save",
  __fbads_setup_more_details: "More details",
  __fbads_setup_facebook_login_button: "Continue with Facebook",
  __fbads_connected_account_business: "Business Account",
  __fbads_connected_account_ads: "Ads Account",
  __fbads_connected_account_pixel: "Pixel ID",
  __fbads_connected_account_status: "Status",
  __fbads_connected_account_connected: "Connected",
  __fbads_connected_account_not_connected: "Connection Problem",
  __fbads_connected_account_error_ads_failed: "Unable to access this Ads account.",
  __fbads_connected_account_error_pixel_failed: "Unable to access this Pixel ID.",
  __fbads_connected_account_error_pixel_connected_ads_failed: "Pixel ID is not linked to the Ads account.",
  __fbads_connected_account_edit: "Edit",
  __fbads_dashboard_lead_pipeline: "Lead Pipeline",
  __fbads_dashboard_lead_conversion_name: "Conversion Name",
  __fbads_dashboard_lead_conversion_total: "Count",
  __fbads_dashboard_lead_conversion_value: "Value",
  __fbads_google_sheets_description: "Data will be sent to Meta Ads account.",
  __fbads_ads_account_not_found: "No results found matching your search or invalid Ads account ID.",
  __fbads_ads_account_search_hint: "Can’t find the ad account you’re looking for? Try searching by keyword or Ads Account ID.",
  __fbads_web_conversion_title: "Web Conversions",
  __fbads_web_conversion_active_confirm: "Do you confirm to activate Web Conversions?",
  __fbads_web_conversion_inactive_confirm: "Do you confirm to deactivate Web Conversions?",
  __fbads_web_conversion_description:
    "Used for campaign objectives with conversion activities occurring on the website, such as Leads Conversions and Sales Conversions.",
  __fbads_crm_conversion_title: "CRM Conversions",
  __fbads_crm_conversion_active_confirm: "Do you confirm to activate CRM Conversions?",
  __fbads_crm_conversion_inactive_confirm: "Do you confirm to deactivate CRM Conversions?",
  __fbads_crm_conversion_connection_crm_warning: "Your Pixel ID is not linked to CRM.",
  __fbads_crm_conversion_description: "Used for the Instant Lead Form campaign objective.",
  __fbads_conversion_no_data: "Nothing to display.",

  // Facebook Leads
  __fbleads_title: "Leads",
  __fbleads_title_description: "Set up data retrieving from Facebook Leads and sending to the connected destinations.",
  __fbleads_google_sheets_tab_setting_modal: "Connection Setting",
  __fbleads_change_status_to_active: "Do you confirm to activate this connection?",
  __fbleads_change_status_to_inactive: "Do you confirm to deactivate this connection?",
  __fbleads_fb_account: "Facebook Account",
  __fbleads_fb_page: "Facebook Page",
  __fbleads_fb_form: "Choose Form",
  __fbleads_google_account: "Google Account",
  __fbleads_google_sheets_url: "Google Sheets",
  __fbleads_google_sheets_file_detail: "File Info",
  __fbleads_edit_connection: "Edit Connection",
  __fbleads_fb_connect: "Connect to Facebook Page.",
  __fbleads_google_connect: "Connect to Google Sheets.",
  __fbleads_fb_all_forn_describe: "Includes forms added later.",
  __fbleads_google_error_search_file: "File not found or you may not have permission to access this file.",
  __fbleads_google_error_search_file_type: "Only Google Sheets is supported.",
  __fbleads_fb_page_not_found: "Page not found.",
  __fbleads_fb_form_not_found: "Form not found.",
  __fbleads_fb_form_used_all_form: "All forms have been used for other connections.",
  __fbleads_fb_error_login: "An error occurred while connecting to Facebook Page. Please try again.",

  // Google Leads
  __googleleads_title: "Leads",
  __googleleads_title_description:
    "Set up data retrieving from Google Leads and sending to the connected destinations.",
  __googleleads_google_ads_account: "Google Ads Account",
  __googleleads_choose_form: "Choose Form",
  __googleleads_google_form_not_found: "Form not found.",
  __googleleads_google_form_used_all_form: "All forms have been used for other connections.",
  __googleleads_google_error_search_file: "File not found or you may not have permission to access this file.",
  __googleleads_google_error_search_file_type: "Only Google Sheets is supported.",
  __googleleads_google_error_change_ads_account: "This Google Ads account is not connected.",

  // Button Action
  __btn_action_edit: "Edit",
  __btn_action_delete: "Delete",
  __btn_action_view: "View",
  __select_lead_source_placeholder: "Choose Lead Source",

  // No Connected Ads
  __noads_description: "No connected Ads account.",
  __noads_setting_button: "Settings",

  // Error Message
  __ads_crm_conversion_conversion_set_duplicate: "Custom Conversion name is already in use.",
  __ads_crm_conversion_conversion_value_not_valid: "Please enter a valid number.",
  __ads_crm_conversion_conversion_set_not_specified: "Please specify a conversion set.",
  __ads_facebook_setting_error: "Connection problem. Please check your settings.",

  // Facebook Conversion Stats
  __conversion_header: "Conversions",
  __fb_conversions_r_widget: "R-Widget",
  __fb_conversions_r_crm: "R-CRM",
  __fb_conversions_google_sheets: "Google Sheets",
  __r_widget_conversions: "R-Widget",
  __r_crm_conversions: "R-CRM",
  __google_sheets_conversions: "Google Sheets",
};
